const domReady = e => {
  const sliders = document.querySelectorAll('.js-product-grid-flkty');

  const reinitFlkty = e => {
    sliders.forEach(slider => {
      let flkty = Flickity.data(slider);
      flkty.resize();
    })
  }
  
  const debounce = (callback, time = 100) => {
    let timer;
    return evt => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(callback, time, evt);
    };
  }
  
  window.addEventListener("resize", debounce(reinitFlkty, 150));

  // PDP Truncated Description
  $(document).on('click', '.product-single__read-description', (e) => {
    let fullDescription = document.querySelector('.product-single__description[data-full]');
    let truncatedDescription = document.querySelector('.product-single__description[data-truncated]');

    e.currentTarget.style.display = 'none';

    fullDescription.classList.remove('hidden');
    truncatedDescription.classList.add('hidden');
  })
}

document.addEventListener('DOMContentLoaded', domReady, false);


// FREE SHIPPING THRESHOLD
const settings = {
  container: 'sl-module-shipping-threshold',
  progress_bar: 'FSTBar',
  message: 'FSTMessage',
  message_error: 'Please enter a target goal amount in the Theme Settings > Shipping Threshold'
};

const container = document.getElementById(settings.container);
let data;

const initData = async () => {
  const dataJson = container.nextElementSibling;

  if (!dataJson) return;

  data = JSON.parse(dataJson.innerText);
}

const fetchCartData = async () => {
  try {
    const res = await fetch(theme.routes.cart ?? '/cart.js');
    const data = await res.json();

    if (res.ok) calculateThreshold(data)
  }
  catch(err) {
    console.log(err);
  }
}

const renderElements = async () => {
  const labelHTML = document.createElement('label')
  labelHTML.classList.add('visually-hidden')
  labelHTML.setAttribute('for', settings.progress_bar)
  labelHTML.textContent = 'Free shipping progress'

  const progressBarHTML = document.createElement('progress')
  progressBarHTML.id = settings.progress_bar
  progressBarHTML.setAttribute('max', 100)
  progressBarHTML.setAttribute('value', 0)

  const progressBarWrapper = document.createElement('div')
  progressBarWrapper.classList.add('fst-progress-bar-wrapper')
  progressBarWrapper.appendChild(progressBarHTML)

  const standardHTML = document.createElement('div')
  standardHTML.classList.add('fst-target', 'fst-standard')
  standardHTML.innerHTML = `<span class="dot"></span>`
  progressBarWrapper.appendChild(standardHTML)

  const expressHTML = document.createElement('div')
  expressHTML.classList.add('fst-target', 'fst-express')
  expressHTML.innerHTML = `<span class="dot"></span>`
  progressBarWrapper.appendChild(expressHTML)

  const messageHTML = document.createElement('div')
  messageHTML.id = settings.message
  messageHTML.classList.add('fst-message')

  container.appendChild(messageHTML);
  container.appendChild(labelHTML);
  container.appendChild(progressBarWrapper);
}

const renderExpressNotes = elem => {
  const express = data.targets.express['AU']

  if (!express) return;
  elem.innerHTML = `Free express shipping over $${express} storewide`;
}

const calculateThreshold = cartJson => {
  const standard = data.targets.standard['AU']
  const express = data.targets.express['AU']

  const target = express ? express : standard ? standard : null;
  const cart_total = (cartJson.total_price ? cartJson.total_price : cartJson.final_price) / 100;
  const progress_value = (cart_total / target) * 100;
  const remaining = target - cart_total;

  let message = '';

  if (target) {
    // Set value of progress bar
    if (progress_value >= 100){
      document.getElementById(settings.progress_bar).setAttribute('value', 100);
      document.getElementById(settings.progress_bar).parentElement.setAttribute('value', 100);
    }
    else {
      document.getElementById(settings.progress_bar).setAttribute('value', progress_value ? progress_value : 0);
      document.getElementById(settings.progress_bar).parentElement.setAttribute('value', progress_value ? progress_value : 0);
    }

    document.getElementById(settings.progress_bar).parentElement.style.setProperty('--standard', standard);
    document.getElementById(settings.progress_bar).parentElement.style.setProperty('--express', express);
    document.getElementById(settings.progress_bar).parentElement.style.setProperty('--standardPosition', (standard / express) * 100);

    if (express && standard) {
      let standardHTML = document.querySelector('.fst-target.fst-standard');
      if (standardHTML) {
        if (remaining <= express - standard) {
          standardHTML.classList.add('filled');
        } else {
          standardHTML.classList.remove('filled');
        }
      }
    }

    let expressHTML = document.querySelector('.fst-target.fst-express');
    if (remaining <= 0) {
      expressHTML.classList.add('filled');
    } else {
      expressHTML.classList.remove('filled');
    }

    message =
      remaining >= target ? data.messages.default.replace('[target]', `$${target}`) :
      remaining <= 0 ? data.messages.success : data.messages.ongoing.replace('[remaining]', `$${remaining ? remaining.toFixed(2) : target}`);
  }
  else
    message = settings.message_error

  document.getElementById(settings.progress_bar).parentElement.dataset.standard = standard ? true : false;
  document.getElementById(settings.progress_bar).parentElement.dataset.express = express ? true : false;

  // Display message
  document.getElementById(settings.message).innerHTML = message;
}

const reRender = async () => {
  await initData();
  fetchCartData();
}

const init = async () => {
  if (!container) return;

  await initData();
  renderElements();
  fetchCartData();

  // Listeners for product added and cart updates
  ['cart:updated', 'ajaxProduct:added'].forEach(evt => {
    document.addEventListener(evt, reRender, false)
  });

  // Add shipping express notes just below checkout button in cart
  const expressElem = document.querySelector('.js-shipping-threshold-express-notes');
  if (expressElem) renderExpressNotes(expressElem);
}

// DOM LOADED
document.addEventListener('DOMContentLoaded', init, false);

// CART REWARDS
window.addEventListener('DOMContentLoaded', () => {

  const drawerOpenStyles = (panel) => {
    let drawerInner = panel.closest('.drawer__inner');
    let drawerScrollable = drawerInner.querySelector('.drawer__scrollable');

    let windowHeight = window.innerHeight;
    let scrollableHeight = drawerScrollable.scrollHeight;
    let limit = windowHeight - 140;

    drawerInner.style.display = "block";
    drawerScrollable.style.paddingTop = "0";
    drawerScrollable.style.position = "static";
    drawerScrollable.style.height = scrollableHeight > limit ? "auto" : "100%";
  }

  const drawerCloseStyles = (panel) => {
    let drawerInner = false;
    if (panel) {
      drawerInner = panel.closest('.drawer__inner');
    }
    let drawerScrollable = false;

    if (drawerInner) {
      drawerScrollable = drawerInner.querySelector('.drawer__scrollable');
      drawerInner.style.display = "flex";
    }

    if (drawerScrollable) {
      drawerScrollable.style.paddingTop = "15px";
      drawerScrollable.style.position = "relative";
      drawerScrollable.style.height = "auto";
    }
  
  }

  $(document).on('click', '.cart-view-rewards', (e) => {
      let panel = document.querySelector('.cart-rewards-panel');
      drawerOpenStyles(panel);
      panel.classList.add('active');
  })

  $(document).on('click', '.cart-hide-rewards', (e) => {
      let panel = document.querySelector('.cart-rewards-panel');
      drawerCloseStyles(panel);
      panel.classList.remove('active');
  })

  document.addEventListener('drawerClose', () => {
      let panel = document.querySelector('.cart-rewards-panel');
      if (panel) {
        drawerCloseStyles(panel);
        panel.classList.remove('active');
      }
  })

  $(document).on("change", ".cart-cross-sell__product-variant-select", (e) => {
      let parent = e.currentTarget.closest('.cart-cross-sell__product-card');
      let button = parent.querySelector('.cart-rewards__product-atc-btn');

      if (button && button.innerHTML != "Add To Cart") {
          button.innerHTML = "Add To Cart";
      }
  })

  $(document).on('click', '.cart-rewards__product-atc-btn', (e) => {
      const parent = e.currentTarget.closest('.cart-cross-sell__product-card');
      const selector = parent.querySelector('.cart-cross-sell__product-variant-select');

      let selected_variant = selector.options[selector.selectedIndex].value;
      let collection = parent.getAttribute('data-collection');

      if (!selected_variant) return;

      data = {
          "id": selected_variant,
          "quantity": 1,
          "properties": {
              "_free-gift": true,
              "_gift-collection": collection
          }
      }
      
      jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() { 
              document.dispatchEvent(new CustomEvent('cart:build'));

              let panel = document.querySelector('.cart-rewards-panel');
              drawerCloseStyles(panel);
              panel.classList.remove('active');
          }
      });
  })

  const removeItems = (arr) => {
      let data = {};
      arr.forEach(item => {
          data[item] = 0;
      })

      jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: data
      })
      .then(() => {
          document.dispatchEvent(new CustomEvent('cart:build'));
      })
  }

  const getCartData = () => {
      jQuery.getJSON('/cart.js', function(cart) {
          let itemsToRemove = []
          
          cart.items.forEach(item => {
              if (item.properties?.["_free-gift"]) {
                  if (item.final_price > 0) {
                      let key = item.key;
                      itemsToRemove.push(key)
                  }
              }
          })

          if (itemsToRemove.length > 0) {
              removeItems(itemsToRemove);
          }
      } );
  }

  document.addEventListener('cart:updated', async (evt) => {
      setTimeout(() => {
          getCartData();
      }, 1000)
  })

  document.addEventListener('cart:build', async (evt) => {
      setTimeout(() => {
          getCartData();
      }, 1000)
  })

  document.addEventListener('ajaxProduct:added', async (evt) => {
      setTimeout(() => {
          getCartData();
      }, 1000)
  })
})

// Blog load more
function blogLoadMore() {
  jQuery('.js-load-more').on('click', function(){
    const $this =$(this);
    const totalPages = parseInt($('[data-total-pages]').val());
    const nextUrl = $('[data-next-url]').val();
    let currentPage = parseInt($('[data-current-page]').val());
    let nextPage = parseInt($('[data-next-page]').val());
    $this.text('Loading...');
    $this.attr('disabled', true);
    $this.find('[loader]').addClass('btn--loading');
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.blog-listing-wrapper').append($(responseHTML).find('.blog-listing-wrapper').html());
        $('[data-current-page]').val(nextPage);
        nextPage++;
        $('[data-next-page]').val(nextPage);
        $('[data-next-url]').val($('[data-next-url]').val().replace(/page=[0-9]+/,'page='+nextPage));
        if (window.AOS) { AOS.refreshHard() }
      },
      error: function (jqXHR) {
        console.log(jqXHR);
      },
      complete: function() {
        currentPage++;
        if(currentPage < totalPages) {
          $this.text('Load more');
          $this.attr('disabled', false); $this.find('[loader]').removeClass('btn--loading');
        }
        if(currentPage >= totalPages) {
          $this.addClass('hide');
        } 
      }
    })
  });
}
blogLoadMore();

// Blog infinite scroll
const blogListingLoadMore = document.querySelector('[data-section-id="blog-template"] .load-more_wrap');
if(blogListingLoadMore) {
  window.addEventListener("load", (event) => {
    createObserver();
  }, false);

  function createObserver() {
    let observer;

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    };

    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(blogListingLoadMore);
  }

  function handleIntersect(entries, observer) {
    entries.forEach((entry) => {
      if(entry.isIntersecting) {
        $('.js-load-more').click();
      }
    });
  }
}

// PLP Filter Tree Toggle
window.addEventListener('DOMContentLoaded', () => {
  let filter_item = document.querySelector('.grid__item--sidebar');
  let products_item = document.querySelector('.grid__item--content');

  $(document).on('click', '.collection-filter-btn', (e) => {
    e.currentTarget.classList.toggle('active')
    filter_item.classList.toggle('collapsed-filters')
    products_item.classList.toggle('collapsed-filters')
  })
})

// ALSO AVAILABLE IN
theme.GraphQL = {

  config:  {
      storefront_token: 'ab735fdee7cd30c76f4e567e719bff34',
      request_url: theme.routes.storefrontAPI
  },

  sendRequest: function(request, request_group, output_container) {

      if(this.config[request_group] == null) {
          this.config[request_group] = 1;
      } else {
          this.config[request_group]++;
      }

      let return_response = null;

      let settings = {
          'crossDomain': true,
          'url': this.config.request_url,
          'method': 'POST',
          'headers': {
              'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
              'Content-Type': 'application/graphql',
          },
          'data': request,
          'success': function(response) {
              theme.GraphQL.config[request_group]--;
              return_response = response;
          },
          'error': function(xhr, errDesc) {
              theme.GraphQL.config[request_group]--;
              console.log(errDesc);
          }
      };
      $.ajax(settings)
          .done(function() {
              if(request_group === "also-available") {
                  theme.AlsoAvailableIn.buildOutput(return_response);
              }
              theme.GraphQL.cleanUp(request_group);
          });
  },

  cleanUp: function(request_group) {
      if(theme.GraphQL.config[request_group] < 1) {
          $('body').trigger(request_group+":loaded");
          delete this.config[request_group];
      }
  }
};

theme.AlsoAvailableIn = (function() {
  let config = {
      request_query: '',
      current_product: '',
      product_name: '',
      image_url_structure: ''
  };

  let swatch_html = `
  <a class="product-swatch-button {{{swatchCurrent}}}" href="{{{productURL}}}" title="{{{swatchTitle}}}"
     style="background-image:url({{{swatchURL}}});">
  </a>
  `;

  function init(container) {
      let $container = this.$container = $(container);
      config.request_query = $container.data('request-query');
      config.current_product = $container.data('current-product');
      config.image_url_structure = $container.data('image-url-structure');
      config.product_name = $container.data('product-name');

      // Return if there is no colour extension
      let hasColour = $container.data('has-colour');
      // if (!hasColour) return;

      let request_query = `
        {
          shop {
            name
            products(first: 100, query: "title:`+config.request_query+`") {
              edges {
                node {
                  onlineStoreUrl
                  availableForSale
                  title
                  handle
                  featuredImage {
                    originalSrc
                  }
                }
              }
            }
          }
        }
      `;

      try {
          theme.GraphQL.sendRequest(request_query, "also-available");
      }
      catch(err) {
          console.error("Errors in GraphQL: "+err);
      }

  }

  function buildOutput(response) {
      let output_html = '';
      let product_arr = response.data.shop.products.edges;

      if(product_arr.length === 0) {
          return;
      }

      this.$container.show();

      for (let i=0;i<product_arr.length;i++) {
          let product_title = product_arr[i].node.title.split("-");
          let product_handle = product_arr[i].node.handle;
          let product_image = product_arr[i].node.featuredImage?.originalSrc;
          // Ensure matching product titles are correct
          if (product_title[0].trim() != config.product_name) {
              continue;
          }

          // let swatch_url = config.image_url_structure.replace("---productTitle---",product_title[product_title.length-1].toLowerCase().replace(")","").replace(/[^a-z0-9]+/g, '-'));
          let handelized_title = product_title[0].toLowerCase().replace(")","").replace(/[^a-z0-9]+/g, '-');
          // let swatch_url = config.image_url_structure.replace("---productTitle---",product_handle.replace(handelized_title,""));
          let colour_suffix = product_handle.replace(handelized_title,"").replaceAll("-", " ").trim().toUpperCase();
          let swatch_url = product_image;

          let output = swatch_html.replace("{{{swatchURL}}}",swatch_url);
          let productURL = product_arr[i].node.onlineStoreUrl;
          output = output.replace("{{{productURL}}}",productURL);
          // output = output.replace("{{{swatchTitle}}}",product_title[1]);
          output = output.replace("{{{swatchTitle}}}",colour_suffix);
          if(product_arr[i].node.handle === config.current_product) {
              output = output.replace("{{{swatchCurrent}}}","aa-swatch--current");
          } else {
              output = output.replace("{{{swatchCurrent}}}", "");
          }
          output_html += output;
      }

      this.$container.find('.aa-container').append(output_html);
  }

  return {
      init: init,
      buildOutput: buildOutput
  };

})();


$(document).ready(function() {
  $('[data-section-type="also-available"]').each(function() {
      theme.AlsoAvailableIn.init(this);
  });
});

window.addEventListener('DOMContentLoaded', () => {

  // START CART CROSS SELL
  $(document).on('click', '.cart-cross-sell__product-atc-btn', (e) => {
      const parent = e.currentTarget.closest('.cart-cross-sell__product-card');
      const selector = parent.querySelector('.cart-cross-sell__product-variant-select');

      let selected_variant = selector.options[selector.selectedIndex].value;

      if (!selected_variant) return;

      data = {
          "id": selected_variant,
          "quantity": 1
      }
      
      jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() { 
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
          }
      });
  })

  let sliderContainer = document.querySelector('.cart-cross-sell__slider');

  const initCartCrossSellSlider = () => {
    sliderContainer = document.querySelector('.cart-cross-sell__slider:not(.tns-slider)');
    if(sliderContainer) {
      // SLIDER
      var slider = tns({
          container: '.cart-cross-sell__slider',
          items: 1.1,
          slideBy: 1,
          autoplay: false,
          controls: false,
          nav: true,
          navContainer: '.cart-cross-sell__slider-nav',
          mouseDrag: true
      });
    }
  }

  ['cart:build', 'ajaxProduct:added', 'cart:updated'].forEach((evt) => {
    document.addEventListener(evt, () => {
      setTimeout(() => {
        initCartCrossSellSlider();
      }, 500)
    })
  })

  // page load
  setTimeout(() => {
    initCartCrossSellSlider();
  }, 1000)


  // Hide chat widget when cart drawer is open
  document.addEventListener('drawerOpen', () => {
    const chatWidget = document.querySelector('.zsiq_floatmain');
    if (chatWidget) {
      chatWidget.classList.add('u-zIndex-19');
    }
  })

  document.addEventListener('drawerClose', () => {
    const chatWidget = document.querySelector('.zsiq_floatmain');
    if (chatWidget) {
      chatWidget.classList.remove('u-zIndex-19');
    }
  })
})